// PURPOSE: Compose native frontend runtime. CONTRACT: real authenticated API session and explicit error boundaries. DEPENDS: React, Router, Query, native AuthProvider. CEILING: no production fixtures.
import React from 'react';
import { ErrorBoundary } from './error-boundary';
import { installErrorCapture } from './error-reports';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RuntimeRoutes } from './runtime-routes';
import './styles.css';
installErrorCapture();
const queryClient = new QueryClient({ defaultOptions: { queries: { retry: 1, staleTime: 20_000, refetchOnWindowFocus: true }, mutations: { retry: false } } });
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode><ErrorBoundary><QueryClientProvider client={queryClient}><RuntimeRoutes /></QueryClientProvider></ErrorBoundary></React.StrictMode>);

if (import.meta.env.PROD && 'serviceWorker' in navigator) { window.addEventListener('load', () => { void navigator.serviceWorker.register('/sw.js').catch(() => { /* Offline support is optional; normal navigation remains available. */ }); }); }
